function HotspotRight(id, selector, d){

    var self = this;

    self.id = selector+ id;

    self.$hotspot = $( ".hover-wrapper" , self.id);
    self.$hover = $( ".hover" , self.id);
    self.$more = $( ".more" , self.id);
    self.$top = $( ".top" , self.id);
    self.$bottom = $( ".bottom" , self.id);

    self.width = self.$hotspot.width();
    self.height = self.$hotspot.height();

    if (self.height< 330){

        self.targetAlpha = 0;
    } else {

        self.targetAlpha = 1;
    }

    console.log("w "+ self.width + " h "+ self.height);

    self.mouseover=false;
    self.timeout =0;

    TweenMax.set(self.$hover, {width:self.width, height: self.height, scaleX: 1, scaleY: 1});

    var bSize = self.width + "px " + self.width*4 + "px";

    TweenMax.set(self.$hover, {backgroundSize:bSize });
    TweenMax.set(self.$top, {left: -d});
    TweenMax.set(self.$bottom, {right: -d});



    if(!Modernizr.touch){

        //console.log("not touch");

        self.$hotspot.mouseover(function() {

            console.log("hover-wrapper over right");

          console.log(" self.targetAlpha; ", self.targetAlpha)

            clearTimeout(self.timeout);

            //self.animsKill();
            TweenMax.to(self.$more, 0.1, {autoAlpha: self.targetAlpha});
            TweenMax.to(self.$hover, 0.2, {autoAlpha: 0.95, scaleX: 1.2, scaleY: 1.2});
            TweenMax.to(self.$top, 0.2, {left: "10%", delay:0.2});
            TweenMax.to(self.$bottom, 0.2, {right: "10%", delay:0.2});
            TweenMax.set(self.$top, {autoAlpha:self.targetAlpha});
            TweenMax.set(self.$bottom, {autoAlpha:self.targetAlpha});


        });

        self.$hotspot.mouseout(function() {

            console.log("hover-wrapper out right");

            clearTimeout(self.timeout);

            self.timeout = setTimeout(function () {

              console.log("timeout");

                TweenMax.to(self.$more, 0.1, {autoAlpha: 0});
                TweenMax.to(self.$top, 0.2, {left: -d});
                TweenMax.to(self.$bottom, 0.2, {right: -d});
                TweenMax.to(self.$hover, 0.25, {top:"10px", autoAlpha: 0, scaleX: 1, scaleY: 1, delay:0.1});


            }, 100);


        });

        self.$more.mouseover(function() {

           // clearTimeout(self.timeout);

            console.log("more over");

            TweenMax.to(self.$top, 0.15, {top: -5});
            TweenMax.to(self.$bottom, 0.15, {bottom: -5});


        });
        self.$more.mouseout(function() {

           // clearTimeout(self.timeout);

            console.log("more out");

            TweenMax.to(self.$top, 0.15, {top: 0});
            TweenMax.to(self.$bottom, 0.15, {bottom: 0});


        });
    } else {

        TweenMax.set(self.$hotspot, {AutoAlpha: 0});
        TweenMax.set(self.$hover, {AutoAlpha: 0});
    }


    $( window ).resize(function() {

        self.resize();

    });



}
HotspotRight.prototype.animsKill = function () {

    var self = this;

    TweenMax.killTweensOf(self.$top);
    TweenMax.killTweensOf(self.$bottom);
    TweenMax.killTweensOf(self.$hover);


};

HotspotRight.prototype.resize = function () {

    console.log("resize");

    var self = this;


        self.width = self.$hotspot.width();
        self.height = self.$hotspot.height();

        TweenMax.set(self.$hover, {width:self.width, height: self.height, scaleX: 1, scaleY: 1});

        var bSize = self.width + "px " + self.width*4 + "px";

        TweenMax.set(self.$hover, {backgroundSize:bSize });

    if (self.height< 330){

        self.targetAlpha = 0;
    } else {

        self.targetAlpha = 1;
    }


};



